import { useTheme } from 'styled-components';

export const ValidationIcon: React.FC<{ className?: string }> = ({ className }) => {
  const theme = useTheme();
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 0C8.8169 0 5.76564 1.26416 3.51415 3.51415C1.26416 5.76561 0 8.81701 0 12C0 15.183 1.26416 18.2344 3.51415 20.4858C5.76561 22.7358 8.81701 24 12 24C15.183 24 18.2344 22.7358 20.4858 20.4858C22.7358 18.2344 24 15.183 24 12C24 8.81701 22.7358 5.76564 20.4858 3.51415C18.2344 1.26416 15.183 0 12 0ZM10.5 17.3921C10.2598 17.6294 9.93751 17.7641 9.60061 17.7671C9.25197 17.7715 8.91507 17.6367 8.66604 17.3921L5.16801 13.8486L7.043 12.0073L9.63871 14.6323L17.7012 7.00933L19.5 8.88725L10.5 17.3921Z"
        fill={theme.scoreIndicatorColors.positiveValue}
      />
    </svg>
  );
};
